(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["experience-feedback"] && !Shopify.designMode) return;
  try {
    
  function initializeExperienceFeedback(root) {
    if (!root || root.dataset.feedbackReady === 'true') return;
    root.dataset.feedbackReady = 'true';

    var dialog = root.querySelector('[data-feedback-dialog]');
    var title = root.querySelector('[data-feedback-title]');
    var openers = root.querySelectorAll('[data-feedback-open]');
    var closer = root.querySelector('[data-feedback-close]');
    var reference = root.querySelector('[data-attention-reference]');
    var referenceLabel = root.querySelector('[data-attention-reference-label]');
    var referenceInput = root.querySelector('[data-attention-reference-input]');
    var attentionChoices = root.querySelectorAll('[data-attention-choice]');
    var lastOpener = null;

    if (!dialog) return;

    function showDialog(opener) {
      lastOpener = opener || null;
      if (typeof dialog.showModal === 'function') {
        if (!dialog.open) dialog.showModal();
      } else {
        dialog.setAttribute('open', '');
      }
      window.requestAnimationFrame(function () {
        if (title) title.focus({ preventScroll: true });
      });
    }

    function closeDialog() {
      if (typeof dialog.close === 'function') dialog.close();
      else dialog.removeAttribute('open');
    }

    function syncAttentionReference() {
      var checked = root.querySelector('[data-attention-choice]:checked');
      var value = checked ? checked.value : '';
      var needsReference = value === root.dataset.collaboratorValue || value === root.dataset.branchValue;

      if (reference) reference.hidden = !needsReference;
      if (referenceInput) {
        referenceInput.disabled = !needsReference;
        referenceInput.required = needsReference;
        if (!needsReference) referenceInput.value = '';
      }
      if (referenceLabel && needsReference) {
        referenceLabel.textContent = value === root.dataset.collaboratorValue
          ? root.dataset.collaboratorLabel
          : root.dataset.branchLabel;
      }
    }

    openers.forEach(function (opener) {
      opener.addEventListener('click', function () { showDialog(opener); });
    });
    if (closer) closer.addEventListener('click', closeDialog);

    dialog.addEventListener('click', function (event) {
      if (event.target === dialog) closeDialog();
    });
    dialog.addEventListener('close', function () {
      if (lastOpener && document.contains(lastOpener)) lastOpener.focus({ preventScroll: true });
      lastOpener = null;
    });

    attentionChoices.forEach(function (choice) {
      choice.addEventListener('change', syncAttentionReference);
    });
    syncAttentionReference();

    var response = root.querySelector('[data-feedback-response]');
    if (response) {
      showDialog();
      window.requestAnimationFrame(function () { response.focus({ preventScroll: true }); });
    }
  }

  document.querySelectorAll('[data-experience-feedback]').forEach(initializeExperienceFeedback);
  document.addEventListener('shopify:section:load', function (event) {
    event.target.querySelectorAll('[data-experience-feedback]').forEach(initializeExperienceFeedback);
  });

  } catch(e) { console.error(e); }
})();
})();
